module.exports = __webpack_public_path__ + "img/b_s_5.fe0676bb.png";